import { Injectable } from "@angular/core";
import { CHANNEL_OPS_INT_ACTION, OpsIntActionResponse } from "../IOpsIntActionService";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
  FnTransferableArg,
} from "shared/provider-webworker";
import { Subject } from "rxjs";
import { OpsIntPromiseActionService } from "./OpsIntPromiseActionService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class OpsIntReplicaActionService extends OpsIntPromiseActionService {
  protected broker: ClientMessageBroker;
  modelNotificationFailureEventSubject: Subject<any> = new Subject<any>();
  protected clientRefreshPort: MessagePort = null;

  constructor(protected factory: ClientMessageBrokerFactory) {
    super();
    this.broker = this.factory.createMessageBroker(CHANNEL_OPS_INT_ACTION, true, true);
  }

  cancelOrder(opsIntId: string[]): Promise<CubiqTS.ServiceResponse> {
    let request = new UiArguments("cancelOrder");

    let arg1 = new FnArg(opsIntId, PRIMITIVE);

    request.args = [arg1];

    return this.broker.runOnService(request, CubiqTS.ENCODABLE(CubiqTS.ServiceResponseImpl));
  }

  clear(
    opsIntId: string[],
    comment: string,
    externalDealId: string | null,
    options: object = {},
  ): Promise<CubiqTS.ServiceResponse> {
    let request = new UiArguments("clear");

    let arg1 = new FnArg(opsIntId, PRIMITIVE);
    let arg2 = new FnArg(comment, PRIMITIVE);
    let arg3 = new FnArg(externalDealId, PRIMITIVE);
    let arg4 = new FnArg(options, PRIMITIVE);

    request.args = [arg1, arg2, arg3, arg4];

    return this.broker.runOnService(request, CubiqTS.ENCODABLE(CubiqTS.ServiceResponseImpl));
  }

  reprice(opsIntId: string[]): Promise<CubiqTS.ServiceResponse> {
    let request = new UiArguments("clear");

    let arg1 = new FnArg(opsIntId, PRIMITIVE);

    request.args = [arg1];

    return this.broker.runOnService(request, CubiqTS.ENCODABLE(CubiqTS.ServiceResponseImpl));
  }

  resend(opsIntId: string[]): Promise<CubiqTS.ServiceResponse> {
    let request = new UiArguments("clear");

    let arg1 = new FnArg(opsIntId, PRIMITIVE);

    request.args = [arg1];

    return this.broker.runOnService(request, CubiqTS.ENCODABLE(CubiqTS.ServiceResponseImpl));
  }
}
